import ApiService from '@/services/core/api.service'

const ItemDetailService = {
  async get (query) {
    return ApiService.get(`user/item-details?${query}`)
  }
}

export default ItemDetailService
